/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * First event emitted by `GET /vehicle/search/{search_id}/stream`. Tells
 * the client how many result batches to expect so it can render a
 * deterministic progress indicator. Direct analog of
 * `SearchStreamBatchStart` on the hotel side.
 * 
 * @export
 * @interface VehicleStreamBatchStart
 */
export interface VehicleStreamBatchStart {
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamBatchStart
     */
    type: VehicleStreamBatchStartTypeEnum;
    /**
     * Total number of result batches in this search.
     * @type {number}
     * @memberof VehicleStreamBatchStart
     */
    totalBatches: number;
}


/**
 * @export
 */
export const VehicleStreamBatchStartTypeEnum = {
    BatchStart: 'batch_start'
} as const;
export type VehicleStreamBatchStartTypeEnum = typeof VehicleStreamBatchStartTypeEnum[keyof typeof VehicleStreamBatchStartTypeEnum];


/**
 * Check if a given object implements the VehicleStreamBatchStart interface.
 */
export function instanceOfVehicleStreamBatchStart(value: object): value is VehicleStreamBatchStart {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('totalBatches' in value) || value['totalBatches'] === undefined) return false;
    return true;
}

export function VehicleStreamBatchStartFromJSON(json: any): VehicleStreamBatchStart {
    return VehicleStreamBatchStartFromJSONTyped(json, false);
}

export function VehicleStreamBatchStartFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleStreamBatchStart {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'totalBatches': json['total_batches'],
    };
}

export function VehicleStreamBatchStartToJSON(json: any): VehicleStreamBatchStart {
    return VehicleStreamBatchStartToJSONTyped(json, false);
}

export function VehicleStreamBatchStartToJSONTyped(value?: VehicleStreamBatchStart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'total_batches': value['totalBatches'],
    };
}

